/**
 * BillingDunning read-only signalling, kept free of React so BaseApiService can import it.
 */

/** Window event dispatched when the server answers 403 TEAM_BILLING_READ_ONLY. */
export const TEAM_BILLING_READ_ONLY_EVENT = 'teamBillingReadOnly';

/** The 403 body code the API uses for a write refused because the team is read-only. */
export const TEAM_BILLING_READ_ONLY_CODE = 'TEAM_BILLING_READ_ONLY';

/** Where a billing manager goes to pay. */
export const TEAM_BILLING_PATH = '/settings/team/billing';

export interface TeamBillingReadOnlyEventDetail {
    message?: string;
    graceEndsAt?: string;
}

export function isTeamBillingReadOnlyError(error: unknown): boolean {
    const e = error as { status?: number; details?: { code?: string } } | null | undefined;
    return e?.status === 403 && e?.details?.code === TEAM_BILLING_READ_ONLY_CODE;
}

export function dispatchTeamBillingReadOnly(detail: TeamBillingReadOnlyEventDetail): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent<TeamBillingReadOnlyEventDetail>(TEAM_BILLING_READ_ONLY_EVENT, { detail }));
}

/**
 * The case editor shows its own read-only modal (it also stops autosave), so the app-level
 * listener stays quiet while one is mounted. A counter, not a boolean, so a remount overlap
 * cannot clear it early.
 */
let caseEditorOwners = 0;

export function claimBillingReadOnlyModal(): () => void {
    caseEditorOwners += 1;
    let released = false;
    return () => {
        if (released) return;
        released = true;
        caseEditorOwners = Math.max(0, caseEditorOwners - 1);
    };
}

export function isBillingReadOnlyModalClaimed(): boolean {
    return caseEditorOwners > 0;
}
